import React from 'react';
import { Logo } from './Logo';
import { Button } from './Button';
import { ThemeToggle } from './ThemeToggle';
const Header = () => {
  return <header className="w-full border-b border-gray-200 dark:border-dark-border bg-background dark:bg-dark-background md:static" data-id="element-36">
      {/* Fixed positioning only on mobile */}
      <div className="fixed top-0 left-0 right-0 z-10 md:static md:border-0 bg-white dark:bg-[#1b1f23] transition-colors" data-id="element-37">
        <div className="max-w-full md:max-w-[1128px] mx-auto px-4 py-2 flex justify-between items-center md:py-2" data-id="element-38">
          {/* Desktop header */}
          <div className="hidden md:block" data-id="element-39">
            <Logo size={34} data-id="element-40" />
          </div>
          <div className="hidden md:flex items-center gap-2" data-id="element-41">
            <ThemeToggle data-id="element-42" />
            <a href="https://forms.office.com/pages/responsepage.aspx?id=v4j5cvGGr0GRqy180BHbR6fDoxh-HzVGmyoQOI03pZNUQTRLTlhJSkk2WVZZUjNVMDNNWENQQzZUNi4u&route=shorturl" target="_blank" data-id="element-43">
              <Button type="secondary" size="small" className="font-medium !font-normal dark:text-[#71B7FB] dark:border-[#71B7FB] dark:bg-dark-background dark:hover:bg-[rgb(55_143_233_/_0.25)]" style={{
              fontWeight: 500
            }} data-id="element-44">
                Become a partner
              </Button>
            </a>
          </div>
          {/* Mobile header */}
          <div className="flex items-center justify-between w-full md:hidden" data-id="element-45">
            <div className="flex items-center" data-id="element-46">
              <Logo size={34} noLink={true} data-id="element-47" />
            </div>
            <div className="flex items-center gap-2" data-id="element-48">
              <ThemeToggle data-id="element-49" />
              <a href="https://forms.office.com/pages/responsepage.aspx?id=v4j5cvGGr0GRqy180BHbR6fDoxh-HzVGmyoQOI03pZNUQTRLTlhJSkk2WVZZUjNVMDNNWENQQzZUNi4u&route=shorturl" target="_blank" data-id="element-50">
                <Button type="secondary" size="small" className="font-medium !font-normal dark:text-[#71B7FB] dark:border-[#71B7FB] dark:bg-dark-background dark:hover:bg-[rgb(55_143_233_/_0.25)]" style={{
                fontWeight: 500
              }} data-id="element-51">
                  Become a partner
                </Button>
              </a>
            </div>
          </div>
        </div>
        <div className="border-b border-gray-200 dark:border-dark-border md:hidden" data-id="element-52"></div>
      </div>
      {/* Spacer to prevent content from hiding behind fixed header on mobile */}
      <div className="h-[49px] md:hidden" data-id="element-53"></div>
    </header>;
};
export default Header;